import { Button } from 'design-system/button/Button'
import React from 'react'
import { DeleteOutlined } from '@ant-design/icons'

type WithdrawAllButtonProps = {
  handleWithdrawAll: () => void
  loading: boolean
}

export const WithdrawAllButton = ({
  handleWithdrawAll,
  loading,
}: WithdrawAllButtonProps) => {
  return (
    <Button
      onClick={handleWithdrawAll}
      variant="danger"
      size="large"
      loading={loading}
    >
      <DeleteOutlined style={{ marginRight: '8px' }} />
      Withdraw All
    </Button>
  )
}
